import { registerAssistAgentMutation } from '@adornis/chat-assist/api/registerAssistAgentMutation.js';
import { teachingAssistant } from '../server/teaching-assistant-agent.js';

// guarded by the VIEW_TEACHING_ASSISTANT gate in operation-policies.ts, like the assist's own operations
export const askTeachingAssistant = registerAssistAgentMutation({
  operationName: 'askTeachingAssistant',
  agent: teachingAssistant,
});
